module.exports = __webpack_public_path__ + "static/media/fundo_login_1920x1085.5bfe2c01.png";